import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import { isHomePage } from "../../utils/isHomePage";

const initNocplacesSwiper = () => {
  const swiperElement = document.querySelector(".nocplaces-swiper-container");

  if (!swiperElement) return;

  new Swiper(swiperElement, {
    modules: [Autoplay],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    grabCursor: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });
};

// Initialize on DOM load
document.addEventListener("DOMContentLoaded", initNocplacesSwiper);

// Initialize on dynamic content load if on homepage
if (isHomePage()) {
  document.addEventListener("bottomContentLoaded", initNocplacesSwiper);
}
